import React, { useEffect, useState } from 'react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300" style={{
    backgroundColor: scrolled ? 'rgba(247, 245, 240, 0.95)' : 'transparent',
    backdropFilter: scrolled ? 'blur(12px)' : 'none',
    borderBottom: scrolled ? '1px solid var(--border)' : '1px solid transparent'
  }} data-id="element-46">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-47">
        <a href="/" className="flex items-center" data-id="element-48">
          <img src="https://cdn.magicpatterns.com/uploads/k9FqYSBkvUsYyBue8z7vuu/abcd_logo.png" alt="abc design" style={{
          height: '58px',
          width: 'auto'
        }} data-id="element-49" />
        </a>
        <a href="https://calendly.com/danielle-abc/30min" target="_blank" rel="noopener noreferrer" className="text-sm transition-all duration-200 hover:opacity-70" style={{
        color: 'var(--text)',
        fontFamily: 'var(--font-sans)'
      }} data-id="element-50">
          Book now
        </a>
      </div>
    </nav>;
}